import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BASE_URL_TOKEN, TenantFeatureFlag } from '@raptor-fe/core';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';

@Injectable({
    providedIn: 'root',
})
export class TenantFeatureFlagService {
    private readonly http = inject(HttpClient);
    private readonly base_url = `${inject(BASE_URL_TOKEN)}v1/tenant/`;
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    /**
     * Gets all feature flags for the tenant
     */
    getAll(tenantId: string): Observable<TenantFeatureFlag[]> {
        return this.http.get<TenantFeatureFlag[]>(`${this.base_url}${tenantId}/tenantfeatureflag`, {
            headers: this.httpHeadersWithNoLoading,
        });
    }

    /**
     * Toggles a feature flag for the tenant. Returns the full set of rows whose state was
     * mutated by the call -- the target flag plus any descendants disabled by cascade.
     */
    toggle(tenantId: string, featureFlag: TenantFeatureFlag): Observable<TenantFeatureFlag[]> {
        return this.http.post<TenantFeatureFlag[]>(`${this.base_url}${tenantId}/tenantfeatureflag/toggle`, featureFlag, {
            headers: this.httpHeadersWithNoLoading,
        });
    }
}
